module.exports = __webpack_public_path__ + "img/4.cee1108b.png";